module.exports = __webpack_public_path__ + "img/ring.a40926c0.jpg";